// Allow only literal word characters and punctuation with no Markdown meaning.
// Unknown syntax stays with the existing parser; never decode entities here.
const plainWord = /^[\p{L}\p{N}][\p{L}\p{M}\p{N},.!?:;'’"…-]*$/u;

export function plainHeadingWord(word: string): string | undefined {
  return plainWord.test(word) ? word + "\u00a0" : undefined;
}
